import { Dashboard } from "@/ui";
import clsx from "clsx";
import { SectionList } from "../../components/SectionList";
import { PageHeading } from "../../components/Pageheading";
import { TabNavigation } from "../../components/TabNavigation";
import { CondenseToggle } from "../../components/CondenseToggle";
import { useAtomValue } from "jotai";
import {
    tabNavAtom,
    Tab,
    condensedChartsAtom,
    selectedTabAtom,
} from "../../state";
import { motion } from "framer-motion";
import { SectionContent } from "../../components/SectionContent";
import { getSectionsForTab } from "../../sectionConfig";

function HomePage() {
    const selectedTab = useAtomValue(tabNavAtom);
    const selectedSection = useAtomValue(selectedTabAtom);
    const isCondensed = useAtomValue(condensedChartsAtom);

    const currentSection = getSectionsForTab(selectedTab).find(
        (s) => s.id === selectedSection,
    );

    return (
        <Dashboard>
            <SectionList />
            <div className="relative">
                <div
                    className={clsx("bg-default z-[1000]", "sticky top-0 pb-8")}
                >
                    <PageHeading />
                    <div className="flex items-center justify-between">
                        <TabNavigation />
                        <CondenseToggle />
                    </div>
                </div>

                {selectedTab === Tab.EXECUTIVE_SUMMARY && (
                    <motion.div
                        layout
                        key="analytics-grid"
                        initial={{ opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        className={clsx(
                            "grid gap-8 pb-8",
                            isCondensed ? "grid-cols-2" : "grid-cols-1",
                            "w-full",
                        )}
                    >
                        {(() => {
                            return currentSection ? (
                                <SectionContent
                                    sectionConfig={currentSection}
                                    tabKey={selectedTab}
                                />
                            ) : null;
                        })()}
                    </motion.div>
                )}

                {selectedTab === Tab.PRE_MEMO && (
                    <motion.div
                        layout
                        key="analytics-grid"
                        initial={{ opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        className={clsx(
                            "grid gap-8 pb-8",
                            isCondensed ? "grid-cols-2" : "grid-cols-1",
                            "w-full",
                        )}
                    >
                        {(() => {
                            return currentSection ? (
                                <SectionContent
                                    sectionConfig={currentSection}
                                    tabKey={selectedTab}
                                />
                            ) : null;
                        })()}
                    </motion.div>
                )}

                {selectedTab === Tab.FULL_MEMO && (
                    <motion.div
                        layout
                        key="analytics-grid"
                        initial={{ opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        className={clsx(
                            "grid gap-8 pb-8",
                            isCondensed ? "grid-cols-2" : "grid-cols-1",
                            "w-full",
                        )}
                    >
                        {(() => {
                            return currentSection ? (
                                <SectionContent
                                    sectionConfig={currentSection}
                                    tabKey={selectedTab}
                                    isCondensed={isCondensed}
                                />
                            ) : null;
                        })()}
                    </motion.div>
                )}
            </div>
        </Dashboard>
    );
}

export default HomePage;
